import { useContext } from "react";
import { showToaster } from "../../../../../global/context/action/toaster/toaster";
import { GlobalContext } from "../../../../../global/context/Provider";
import "./PasoDos.css";

const PasoDos = ({setPaso, setViewCovid}) => {
    const {
        toasterDispatch,
      } = useContext(GlobalContext);
    

    const handleClickAceptar = () => {
        setPaso(3); 
    }
    const handleClickRechazar = () => {
        showToaster(
            {
             texto: "Sus datos fueron actualizados. Muchas gracias por su respuesta. Continuemos cuidándonos.",
             tipo: "success",
            },
            "centroArriba"
        )(toasterDispatch)
        setPaso(0)
        setViewCovid(false)
    }
    return (
        <div className="ptur-covidProto-container heightPasoDos">
            <div className="ptur-covidProto-header bgcG-latex30">
                <h1 className="rb24t widthPasoDos">Protocolo posibles casos de coronavirus</h1>
            </div>
            <div className="ptur-covidProto-body-pasoDos">
                <span className="rb16b">¿Tiene dificultad para respirar?</span>
                <div className="ptur-pasoDos-contaienrBtn">
                    <button className="bgc-latex10" onClick={handleClickAceptar}>Si</button>
                    <button className="bgc-latex10" onClick={handleClickRechazar}>No</button>
                </div>
            </div>
        </div>
    )
}

export default PasoDos;